// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Vehicle, VehicleMakeModel } from '@interfaces/vehicle.interfaces';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root',
})
export class VehicleService {
    vehicle: Vehicle;

    constructor(
        private readonly apiService: ApiService,
        private readonly userService: UserService
    ) {}

    searchForVehicle$(searchString: string): Observable<Vehicle[]> {
        return this.apiService
            .getV2$<Vehicle[]>(`api/vehicle/list/${this.userService.user.dealerId}?searchString=${searchString}`)
            .pipe(map((response) => response?.data));
    }

    transformVehicleFromApi(vehicle: Vehicle): Vehicle {
        if (!vehicle) {
            return null;
        }
        return {
            vin: vehicle.vin || '',
            stockNumber: vehicle.stockNumber || '',
            year: vehicle.year || 0,
            make: vehicle.make || '',
            model: vehicle.model || '',
            trim: vehicle.trim || '',
            bodyStyle: vehicle.bodyStyle || '',
            vehicleExt: { ...vehicle.vehicleExt },
            lastUpdateDate: vehicle.lastUpdateDate,
            manuallyCreated: vehicle.manuallyCreated,
        };
    }

    getMakeModels$(dealerId: number): Observable<VehicleMakeModel[]> {
        return this.apiService.getV2$<VehicleMakeModel[]>(`api/vehicle/makeModels/${dealerId}`).pipe(map((response) => response?.data));
    }
}
